module.exports = __webpack_public_path__ + "img/document-alt.04b19b3d.svg";